// extracted by mini-css-extract-plugin
export default {"goBack":"GoBack_goBack__FPkSr"};